import TextField from "@material-ui/core/TextField";
import { LoadingButton } from "@mui/lab";
import {
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useConfirmation from "../hooks/useConfirmation";
import Formservice from "./../service/Formservice";
import CVPreview from "./CVPreview";
import logo from "./logo.png";
import Menu from "./Menu";
import Message from "./Message";

function Resume() {
  //  const params = new URLSearchParams(location.search);
  const ref = localStorage.getItem("ref");
  const parts = ref.split("_");
  const prefix = parts[0];
  const apiurl = process.env.REACT_APP_API_FILE;
  const [identity, setIdentity] = useState({});
  const [etude, setEtude] = useState([]);
  const [experience, setExperience] = useState([]);
  const [autrecpt, setAutrecpt] = useState([]);
  const [load, setLoad] = useState(false);
  const { DialogComponent, openConfirmDialog } = useConfirmation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [cvPreviewInfo, setCvPreviewInfo] = useState({ open: false, cv: null });
  const [message, setMessage] = React.useState({
    open: false,
    color: "green",
    messageInfo: "",
  });
  const { open, color, messageInfo } = message;
  const [form, setForm] = useState({
    com: "",
  });
  const navigate = useNavigate();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm({ ...form, [name]: value });
  };

  const handleOpenCvPreview = () => {
    setCvPreviewInfo({
      open: true,
      cv: `${apiurl}/uploads/cv/${identity.file_cv}`,
    });
  };

  const handleCloseCvPreview = () => {
    setCvPreviewInfo({ open: false, cv: null });
  };

  const handleConfirmSend = () => {
    openConfirmDialog(
      form.id_type === "1" ? "Confirmation de l'envoie des informations": "Confirmer l’envoi de votre candidature",
      `Toutes les informations vu dans le résumé apparaîtront sur votre CV.<br/>
        Avez-vous vérifié qu’elles sont complètes et correctes avant de soumettre? `,
      () => handleenvoie(),
      () => {},
    );
  };

  const handleenvoie = () => {
    form.front_url = window.location.origin;
    setLoad(true);
    Formservice.soumettre(form, ref)
      .then((result) => {
        if (result.status) {
          setMessage({
            ...message,
            open: true,
            color: "green",
            messageInfo: "Succès",
          });
          navigate("/finaly");
        } else {
          setMessage({
            ...message,
            open: true,
            color: "red",
            messageInfo: "Erreur de soumission",
          });
        }
      })
      .catch((err) => {
        setMessage({
          ...message,
          open: true,
          color: "red",
          messageInfo: "erreur",
        });
      })
      .finally(() => {
        setLoad(false);
      });
  };
  const handleretour = () => {
    navigate("/fichier");
  };

  /**Retour vers les pages où les données sont manquantes */
  const handleVerifyData = (data) => {
    if (data.etude.length === 0) {
      navigate("/etude");
    } else if (data.exp.length === 0 && data.data.poste !== "Stagiaire") {
      navigate("/experience");
    }
  };

  useEffect(() => {
    Formservice.details(ref).then((result) => {
      if (result && result.data) {
        setIdentity(result.data);
        setForm({ ...form, com: result.data.comments });
        setEtude(result.etude);
        setExperience(result.exp);
        setAutrecpt(result.autreep);
        handleVerifyData(result);
      } else {
      }
    });
  }, []);
  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }
  return (
    <Grid container style={{ display: "flex", justifyContent: "center" }}>
      <DialogComponent />
      <CVPreview
        open={cvPreviewInfo.open}
        handleClose={handleCloseCvPreview}
        cv={cvPreviewInfo.cv}
        handleEnvoie={handleenvoie}
      />
      <Message
        open={open}
        color={color}
        messageInfo={messageInfo}
        handleClose={handleCloseMessage}
      />
      <Menu />
      <Grid
        item
        xs={12}
        md={10}
        lg={7}
        minHeight={"90vh"}
        borderRadius={"20px"}
        border={"2px rgba(11, 93, 208,0.5) solid "}
        boxShadow="0px 4px 10px rgba(7,71,161,0.4)"
        display={"flex"}
        flexDirection={"column"}
        p={2.5}
      >
        <main>
          <Grid container item xs={12} justifyContent={"center"}>
            <img
              src={logo}
              className="App-logo"
              alt="logo"
              style={{
                maxWidth: "75px",
                maxHeight: "75px",
                // marginLeft: "40%",
                // display: window.innerWidth <= 600 ? "block" : "none",
              }}
            />
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Grid container item xs={12} justifyContent="center">
              <h1 style={{ marginBottom: "10px" }}>Résumé</h1>
              <br />
            </Grid>
            <TableContainer
              component={Paper}
              sx={{ width: { xs: "88vw", md: "78vw", lg: "54vw" } }}
              style={{
                marginTop: "10px",
                marginBottom: "20px",
              }}
            >
              <Table>
                <TableHead>
                  {prefix !== "CI" && (
                    <TableRow>
                      <TableCell>Poste </TableCell>
                      <TableCell>{identity.poste}</TableCell>
                    </TableRow>
                  )}
                  <TableRow>
                    <TableCell>Nom et Prénom(s) </TableCell>
                    <TableCell>{identity.nom}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Date de naissance </TableCell>
                    <TableCell>{identity.ddn}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Adresse </TableCell>
                    <TableCell>{identity.adresse}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Contact </TableCell>
                    <TableCell>{identity.contact}</TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>
            <TableContainer
              component={Paper}
              sx={{ width: { xs: "88vw", md: "78vw", lg: "54vw" } }}
              style={{
                marginTop: "10px",
                marginBottom: "20px",
              }}
            >
              <Table>
                <TableHead>
                  <TableRow style={{ backgroundColor: "gray", padding: "0px" }}>
                    <TableCell>Année </TableCell>
                    <TableCell>Diplôme</TableCell>
                    <TableCell>Etablissement</TableCell>
                    <TableCell>Filière</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {etude.map((data, index) => (
                    <TableRow key={index}>
                      <TableCell>{data.annee}</TableCell>
                      <TableCell>{data.diplome}</TableCell>
                      <TableCell>{data.etablissement}</TableCell>
                      <TableCell>{data.filiere}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TableContainer
              component={Paper}
              sx={{ width: { xs: "88vw", md: "78vw", lg: "54vw" } }}
              style={{
                marginTop: "10px",
                marginBottom: "20px",
              }}
            >
              <Table>
                <TableHead>
                  <TableRow style={{ backgroundColor: "gray", padding: "0px" }}>
                    <TableCell>Date </TableCell>
                    <TableCell>Entreprise</TableCell>
                    <TableCell>Domaine</TableCell>
                    <TableCell>Sous_domaine</TableCell>
                    <TableCell>Statut d'emploi</TableCell>
                    <TableCell>Poste occupée</TableCell>
                    <TableCell>Mission</TableCell>
                    <TableCell>PJ</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {experience.map((data, index) => (
                    <TableRow key={index}>
                      {/* <TableCell>{data.periode}</TableCell> */}
                      {data.date_fin !== "00/00/0000" ? (
                        <TableCell>
                          {data.date_debut} - {data.date_fin}
                        </TableCell>
                      ) : (
                        <TableCell>
                          {data.date_debut} - {data.fin_contrat}
                        </TableCell>
                      )}
                      <TableCell>{data.organisme_experience}</TableCell>
                      <TableCell>{data.domaine_experience}</TableCell>
                      <TableCell>{data.sous_domaine_experience}</TableCell>
                      <TableCell>{data.statut}</TableCell>
                      <TableCell>{data.experience_mission}</TableCell>
                      <TableCell>{data.description_experience}</TableCell>
                      <TableCell>
                        {data.file_experience == "" ? (
                          ""
                        ) : (
                          <a
                            href={`${apiurl}/uploads/attestation/${data.file_experience}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            PJ
                          </a>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TableContainer
              component={Paper}
              sx={{ width: { xs: "88vw", md: "78vw", lg: "54vw" } }}
              style={{
                marginTop: "10px",
                marginBottom: "20px",
              }}
            >
              <Table>
                <TableHead>
                  <TableRow style={{ backgroundColor: "gray", padding: "0px" }}>
                    <TableCell>Competence </TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Niveau</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {autrecpt
                    .filter(
                      (data, index, self) =>
                        index ===
                        self.findIndex(
                          (t) =>
                            t.competence === data.competence &&
                            t.type === data.type &&
                            t.niveau === data.niveau,
                        ),
                    )
                    .map((data, index) => (
                      <TableRow key={index}>
                        <TableCell>{data.competence}</TableCell>
                        <TableCell>{data.type}</TableCell>
                        <TableCell>{data.niveau}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TableContainer
              component={Paper}
              sx={{ width: { xs: "88vw", md: "78vw", lg: "54vw" } }}
              style={{
                marginTop: "10px",
                marginBottom: "20px",
              }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>CV </TableCell>
                    <TableCell>
                      <a
                        href={`${apiurl}/uploads/cv/${identity.file_cv}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        PJ
                      </a>
                    </TableCell>
                  </TableRow>
                  {prefix !== "CI" && (
                    <TableRow>
                      <TableCell>LM </TableCell>
                      <TableCell>
                        <a
                          href={`${apiurl}/uploads/lm/${identity.lm}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          PJ
                        </a>
                      </TableCell>
                    </TableRow>
                  )}
                  <TableRow>
                    <TableCell>Signature </TableCell>
                    <TableCell>
                      <a
                        href={`${apiurl}/uploads/signature/${identity.file_diplome}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        PJ
                      </a>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Photos </TableCell>
                    <TableCell>
                      <a
                        href={`${apiurl}/uploads/photo/${identity.photo}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        PJ
                      </a>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>NIF </TableCell>
                    <TableCell>
                      <a
                        href={`${apiurl}/uploads/nif/${identity.file_carte_fiscal}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        PJ
                      </a>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>STAT </TableCell>
                    <TableCell>
                      <a
                        href={`${apiurl}/uploads/stat/${identity.file_carte_stat}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        PJ
                      </a>
                    </TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>

            <Grid item xs={12}>
              <TextField
                style={{ width: "100%", marginBottom: "30px" }}
                id="outlined-basic"
                size="small"
                label="Commentaire"
                variant="outlined"
                name="com"
                multiline
                rows={5}
                value={form.com}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
          <Grid
            container
            xs={12}
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
            mt={4}
          >
            <Grid item>
              <Button
                variant="outlined"
                color="primary"
                style={{
                  fontWeight: 600,
                  width: isMobile ? "100%" : "auto",
                  marginBottom: "20px",
                }}
                onClick={handleretour}
              >
                Retour
              </Button>
            </Grid>
            <Grid item>
              {/* <LoadingButton
                loading={load}
                variant="contained"
                color="primary"
                style={{
                  fontWeight: 600,
                  width: isMobile ? "100%" : "auto",
                  marginBottom: "20px",
                }}
                onClick={() => handleOpenCvPreview()}
              >
                Voir CV
              </LoadingButton> */}
              <LoadingButton
                loading={load}
                variant="contained"
                color="primary"
                style={{
                  fontWeight: 600,
                  width: isMobile ? "100%" : "auto",
                  marginBottom: "20px",
                }}
                onClick={handleConfirmSend}
                // onClick={() => handleOpenCvPreview()}
              >
                VALIDER
              </LoadingButton>
            </Grid>
          </Grid>
        </main>
        <footer
          style={{
            color: "#0747a1",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          &copy; {new Date().getFullYear()} FID - FONDS D'INTERVENTION POUR LE
          DEVELOPPEMENT
        </footer>
      </Grid>
    </Grid>
  );
}

export default Resume;
